/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtifactToolCallResponseContent
 */
export interface ArtifactToolCallResponseContent {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ArtifactToolCallResponseContent
     */
    response: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallResponseContent
     */
    tool: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallResponseContent
     */
    callId: string;
}

/**
 * Check if a given object implements the ArtifactToolCallResponseContent interface.
 */
export function instanceOfArtifactToolCallResponseContent(value: object): value is ArtifactToolCallResponseContent {
    if (!('response' in value) || value['response'] === undefined) return false;
    if (!('tool' in value) || value['tool'] === undefined) return false;
    if (!('callId' in value) || value['callId'] === undefined) return false;
    return true;
}

export function ArtifactToolCallResponseContentFromJSON(json: any): ArtifactToolCallResponseContent {
    return ArtifactToolCallResponseContentFromJSONTyped(json, false);
}

export function ArtifactToolCallResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactToolCallResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'response': json['response'],
        'tool': json['tool'],
        'callId': json['callId'],
    };
}

export function ArtifactToolCallResponseContentToJSON(json: any): ArtifactToolCallResponseContent {
    return ArtifactToolCallResponseContentToJSONTyped(json, false);
}

export function ArtifactToolCallResponseContentToJSONTyped(value?: ArtifactToolCallResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response': value['response'],
        'tool': value['tool'],
        'callId': value['callId'],
    };
}

